import Input from '@returnmates/ui-core/src/components/Input'
import { memo } from 'react'
import { Field } from 'react-final-form'

import useStyles from '../styles'

function MetaSettings() {
  const classes = useStyles({})

  return (
    <>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Share title</p>
        <Field name="shareTitle">
          {({ input, meta }) => (
            <Input
              placeholder="Return your packages."
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Description</p>
        <Field name="shareDescription">
          {({ input, meta }) => (
            <Input
              placeholder="Return Online Purchases Without Leaving Home The Hassle The Tape The Post Office. We pick up returns purchased from any online retailer."
              classes={{
                textField: classes.input,
                input: classes.multilineInput,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
              multiline
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Share image</p>
        <Field name="shareImage">
          {({ input, meta }) => (
            <Input
              placeholder="share image"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
    </>
  )
}

export default memo(MetaSettings)
